import Vue from 'vue'

import EiCarousel from '../EiCarousel'

Vue.component(EiCarousel.name, EiCarousel)

import EiFooter from '../EiFooter'

Vue.component(EiFooter.name, EiFooter)

import EiHomeBody from '../EiHomeBody'

Vue.component(EiHomeBody.name, EiHomeBody)

import EiHeader from "../EiHeader";

Vue.component(EiHeader.name, EiHeader)

import EiMask from "../EiMask";

Vue.component(EiMask.name, EiMask)

import EiLongFigureScroll from "../EiLongFigureScroll";

Vue.component(EiLongFigureScroll.name, EiLongFigureScroll);

import EiLongFigureScroll2 from "../EiLongFigureScroll2";

Vue.component(EiLongFigureScroll2.name, EiLongFigureScroll2);

import EiLongFigureScroll3 from "../EiLongFigureScroll3";

Vue.component(EiLongFigureScroll3.name, EiLongFigureScroll3);

import EiHomeBlock1 from "../EiHomeBlock1";

Vue.component(EiHomeBlock1.name, EiHomeBlock1);

import EiHomeBlock2 from "../EiHomeBlock2";

Vue.component(EiHomeBlock2.name, EiHomeBlock2);

import EiHomeBlock3 from "../EiHomeBlock3";

Vue.component(EiHomeBlock3.name, EiHomeBlock3);

import EiHomeBlock4 from "../EiHomeBlock4";

Vue.component(EiHomeBlock4.name, EiHomeBlock4);

import EiHomeBlock5 from "../EiHomeBlock5";

Vue.component(EiHomeBlock5.name, EiHomeBlock5);

import EiHomeBlock6 from "../EiHomeBlock6";

Vue.component(EiHomeBlock6.name, EiHomeBlock6);

import EiHomeBlock7 from "../EiHomeBlock7";

Vue.component(EiHomeBlock7.name, EiHomeBlock7);

import EiCounter from "../EiCounter";

Vue.component(EiCounter.name, EiCounter);

import EiNum from "../EiNum";

Vue.component(EiNum.name, EiNum);

import EiNumList from "../EiNumList";

Vue.component(EiNumList.name, EiNumList);

import EiWord from "../EiWord";

Vue.component(EiWord.name, EiWord);

import EiGoodsDetail from "../EiGoodsDetail";

Vue.component(EiGoodsDetail.name, EiGoodsDetail);

import EiArticleCategory from "../EiArticleCategory";

Vue.component(EiArticleCategory.name, EiArticleCategory);

import EiIndicator from "../EiIndicator";

Vue.component(EiIndicator.name, EiIndicator)

import EiWorksItem from "../EiWorksItem";

Vue.component(EiWorksItem.name, EiWorksItem)

import EiBookItem from "../EiBookItem";

Vue.component(EiBookItem.name, EiBookItem)

import EiArticleDetail from "../EiArticleDetail";

Vue.component(EiArticleDetail.name, EiArticleDetail)

import EiWorksDetail from "../EiWorksDetail";

Vue.component(EiWorksDetail.name, EiWorksDetail)

import EiGoodsItem from "../EiGoodsItem";

Vue.component(EiGoodsItem.name, EiGoodsItem)

import EiPersonDetail from "../EiPersonDetail";

Vue.component(EiPersonDetail.name, EiPersonDetail)

import EiSlideVerity from "../EiSlideVerity";

Vue.component(EiSlideVerity.name, EiSlideVerity)

import EiPages from "../EiPages";

Vue.component(EiPages.name, EiPages)

import EiSearch from "../EiSearch";

Vue.component(EiSearch.name, EiSearch)

import EiTabBar from "../EiTabBar";

Vue.component(EiTabBar.name, EiTabBar)

import EiTypeWriter from "../EiTypeWriter";

Vue.component(EiTypeWriter.name, EiTypeWriter)

import EiRollHor from "../EiRollHor";

Vue.component(EiRollHor.name, EiRollHor)

import EiRightBar from "../EiRightBar";

Vue.component(EiRightBar.name, EiRightBar)

import EiHeadInfo from "../EiHeadInfo";

Vue.component(EiHeadInfo.name, EiHeadInfo)

import EiBackHeadInfo from "../EiBackHeadInfo";
Vue.component(EiBackHeadInfo.name, EiBackHeadInfo)

import EiFlexToolBar from "../EiFlexToolBar";
Vue.component(EiFlexToolBar.name, EiFlexToolBar)

import EiInput from "../EiInput";
Vue.component(EiInput.name, EiInput)

import EiLongFigureScrollAuto from "../EiLongFigureScrollAuto";
Vue.component(EiLongFigureScrollAuto.name,EiLongFigureScrollAuto);

import EiLongFigureScrollForWrite from "../EiLongFigureScrollForWrite";
Vue.component(EiLongFigureScrollForWrite.name,EiLongFigureScrollForWrite);

import EiLongFigureScrollForPerson from "../EiLongFigureScrollForPerson";
Vue.component(EiLongFigureScrollForPerson.name,EiLongFigureScrollForPerson);

import EiLongFigureScrollForPaint from "../EiLongFigureScrollForPaint";
Vue.component(EiLongFigureScrollForPaint.name,EiLongFigureScrollForPaint);

import EiBPlayer from '@/eiuov-ui/EiBPlayer';
Vue.component(EiBPlayer.name,EiBPlayer);

import EiWorksPage from '@/eiuov-ui/EiWorksPage'
Vue.component(EiWorksPage.name,EiWorksPage);

import EiWorksList from '@/eiuov-ui/EiWorksList'
Vue.component(EiWorksList.name,EiWorksList);

import DropdownPluginWriter from '@/eiuov-ui/DropdownPluginWriter'
Vue.component(DropdownPluginWriter.name,DropdownPluginWriter);

import DropdownPluginPainter from '@/eiuov-ui/DropdownPluginPainter'
Vue.component(DropdownPluginPainter.name,DropdownPluginPainter);


import EiMusic from '@/eiuov-ui/EiMusic'
Vue.component(EiMusic.name,EiMusic);

import EiStarLight from '@/eiuov-ui/EiStarLight'
Vue.component(EiStarLight.name,EiStarLight);






